import React, { useState } from 'react';
import './FaqAccordion.css';

/*
 * Shared FAQ expand/collapse logic. Each page keeps its own CSS untouched —
 * pass in the exact class names already used on that page's stylesheet so
 * visual output is unchanged.
 */
function FaqAccordion({
  headingText = 'Frequently Asked Questions',
  items,
  wrapAnswerInParagraph = false,
  classNames,
}) {
  const [openIndex, setOpenIndex] = useState(null);
  const { section, container, heading, list, item, itemOpen, question, questionText, icon, answer } = classNames;

  return (
    <section className={section}>
      <div className={container}>
        <h4 className={heading}>{headingText}</h4>
        <div className={list}>
          {items.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className={`${item}${isOpen ? ` ${itemOpen}` : ''}`}>
                <button
                  className={question}
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span className={questionText}>{f.q}</span>
                  <span className={icon} aria-hidden="true">{isOpen ? '−' : '+'}</span>
                </button>
                <div className={`faq-accordion__collapse${isOpen ? ' faq-accordion__collapse--open' : ''}`}>
                  <div className="faq-accordion__collapse-inner" aria-hidden={!isOpen}>
                    <div className={answer}>
                      {wrapAnswerInParagraph ? <p>{f.a}</p> : f.a}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FaqAccordion;
